<script setup lang="ts">
  import { usePackages } from '@/composables/usePackages';
  import type { PackageSectionData } from '@/models/package';
  import type { PropType } from 'vue';
  import PackageCard from './use-case-packages/PackageCard.vue';

  defineProps({
    packageSectionData: {
      type: Object as PropType<PackageSectionData>,
      required: true
    },
    localePath: {
      type: Function as PropType<(to: any) => string>,
      required: true
    },
    useCaseSlug: {
      type: String,
      required: true
    }
  });

  defineEmits(['onSelect']);

  const { containerRef, swiperRef } = usePackages();

  const onContactUs = () => {
    const element = document.querySelector('#contact-section');

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

</script>

<template>
  <section>
    <div
      ref="containerRef"
      class="container">
      <div class="use-case-packages-section">
        <div class="use-case-packages-section__heading">
          <h1 v-html="packageSectionData.packageSectionTitle"></h1>
          <p>{{ packageSectionData.packageSectionSubtitle }}</p>
        </div>
        <div class="use-case-packages-section__packages">
          <swiper-container
            ref="swiperRef"
            slides-per-view="auto"
            :space-between="0"
            :loop="false"
            :speed="1000"
            :allow-touch-move="true"
            :centered-slides="false"
            :init="false">
            <swiper-slide
              v-for="(packageItem, index) in packageSectionData.packages"
              :key="index">
              <PackageCard
                :package="packageItem"
                :locale-path="localePath"
                :use-case-slug="useCaseSlug"
                @on-select="$emit('onSelect', packageItem.title)" />
            </swiper-slide>
          </swiper-container>
        </div>
      </div>
      <div class="use-case-packages-section-contact-us">
        <div>{{ $t('package.notFoundText') }}</div>
          <a
            class="use-case-packages-section-contact-us__link"
            @click.prevent.stop="onContactUs">
          {{ $t('package.contactCtaText') }}
        </a>
      </div>
    </div>
  </section>
</template>
